import { render } from "./App.vue?vue&type=template&id=31bef5c6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=31bef5c6&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__